@import '../../../globals/main.scss';
@import './pn-site-selector-common.scss';

pn-site-selector {
  display: flex;
  position: relative;
  justify-content: center;
  max-height: 5.2rem;

  @media screen and (min-width: $siteselector-media-desktop) {
    display: block;
  }
}

.siteselector-heading {
  display: block;
  padding: 0;
  margin-bottom: 1.6rem;

  @media screen and (min-width: $siteselector-media-desktop) {
    display: flex;
    align-items: center;
    margin-top: 0.8rem;
  }
}

.siteselector-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
